// Moves interceptors; on reaching their target point they detonate (the missile
// is removed and a player explosion is spawned in its place).

import type { Explosion, PlayerMissile } from '../state/types';
import type { IntegratePlayers } from './contracts';
import { add, dist, len, scale } from '../geometry/vec2';
import { FIXED_DT } from '../constants';
import { createExplosion } from './explosions';

export const integratePlayers: IntegratePlayers = (state) => {
  if (state.playerMissiles.length === 0) return state;

  let nextId = state.nextEntityId;
  const explosions: Explosion[] = [...state.explosions];
  const survivors: PlayerMissile[] = [];

  for (const m of state.playerMissiles) {
    if (!m.alive) continue;
    const stepLen = len(m.vel) * FIXED_DT;
    if (stepLen >= dist(m.pos, m.target)) {
      explosions.push(createExplosion(nextId++, m.target, 'player'));
      // missile consumed (not carried into survivors)
    } else {
      survivors.push({ ...m, pos: add(m.pos, scale(m.vel, FIXED_DT)) });
    }
  }

  return {
    ...state,
    playerMissiles: survivors,
    explosions,
    nextEntityId: nextId,
  };
};
